import {quizStore} from '@/stores/quiz/quiz';

export default {
   
    setQuizModalMeta(state, {quizModalType, quizModalSubType}) {  
        if(quizModalType === null){
            state.quizModalType = '';
        }

        if(quizModalSubType === null){
            state.quizModalSubType = '';
        }

        if(quizModalType){
            state.quizModalType = quizModalType;
        }
        
        if(quizModalSubType){
            state.quizModalSubType = quizModalSubType;
        }
        

        if(state.quizModalType && state.quizModalSubType){
            
            const activeQuizModule = state[state.quizModalType];
            const activeQuizSubModule = activeQuizModule[state.quizModalSubType];
            
            if(activeQuizSubModule) {
                const screens = activeQuizSubModule?.screens;
                activeQuizSubModule.totalScreens = screens ? Object.keys(screens).length : 0;
            } 
            
        }

    },

    setSelectedQuizTypes(state, {type, subtype}) {  
        state.selectedQuiz = type;
        state.selectedSubQuiz = subtype;
    },


    resetQuiz(state){
        const store = quizStore()
        const module = store.getActiveSubModule()

        if(module){
            const screens = module.screens
            Object.keys(screens).forEach((key)=>{
                const screen = screens[key] 
                switch(screen?.type){
                    case 'select' || 'quality' || 'multiselect':{
                        screen.options.forEach(item=> {
                            item.active = false
                        }) 
                        break;   
                    }

                    case 'price':{
                        screen.options.from = screen.options.min     
                        screen.options.to = screen.options.max
                        break;   
                    }

                    case 'email':{
                        screen.email = ""
                        break;   
                    }
                }    
            })
        }

        module.currentScreen = 0

       return 
    },
    
    async setScreensDataFromApi(state, response){
        
        if(typeof response === 'object' && response !== null && !Array.isArray(response)){

            const store = quizStore()
            const module = store.getActiveSubModule()
            const screens = module?.screens 

            if(screens){

                Object.keys(response).forEach((key)=>{
                    if(screens.hasOwnProperty(key)){
                        if(key === 'price'){
                            screens.price.options = response[key]
                        }else if(key === 'metal'){
                            const allowedMetals = ['14K','PT']
                            const options = response[key].filter(item => {
                                
                                if(allowedMetals.includes(item?.short_label)){
                                    item.label =  item.label === 'Platinum' ? item.label : `${item.icon} gold`
                                    return true
                                }
    
                                return false
                                
                            })
                            screens[key].options = options 
                        }
                        else if(screens.hasOwnProperty(key)){
                            screens[key].options = response[key] 
                        }
                    }
                })
            }

            
        }
    },
   
    // common
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },

    changeToPrevScreen(state) {
        const store = quizStore()
        const module = store.getActiveSubModule()

        if(module.currentScreen > 0) {
            module.currentScreen = module.currentScreen - 1;
        }

    },

    changeToScreen(state, screenNo) {
        const store = quizStore()
        const module = store.getActiveSubModule()

        // handle base case check for screenNo less than 0 or greater than total screens
        if(module && screenNo >= 0 && screenNo < module.totalScreens) {
            module.currentScreen = screenNo;
        } 
        
    },

    // action for select type input
    setActiveSelectType(state,{screenName,value}){
        const store = quizStore()
        const module = store.getActiveSubModule()

        const screen = module?.screens[screenName];
        
        if(screen && (screen.type === 'select' || screen.type === 'quality')) {
            screen.options.forEach((option) => {
                if(option.value === value) {
                    option.active = !option.active;
                } else {
                    option.active = false;
                }
            })
        }
    },

    // action for multi select type input
    setActiveMultiSelectType(state,{screenName,value}){
        const store = quizStore()
        const module = store.getActiveSubModule()

        const screen = module?.screens[screenName];
        
        if(screen && (screen.type === 'multiselect')) {
            screen.options.forEach((option) => {
                if(option.value === value) {
                    option.active = !option.active;
                } 
            })
        }
    },

    // email
    setUserEmail(state, value) {
        const store = quizStore()
        const module = store.getActiveSubModule()

        const emailScreen = module?.screens?.email;
        
        if(emailScreen) {
            emailScreen.email = value;
        }
    },

    
}
